import { evalExpression } from 'ecma-evaluator'
import {
  foldFormRuleExpression,
  FormRuleExpressionHelpers,
} from './formRuleExpression.preprocess'

export type { FormRuleExpressionHelpers } from './formRuleExpression.preprocess'

const BLOCKED_EXPRESSION_PATTERNS = [
  /\bimport\b/,
  /\brequire\b/,
  /\bfetch\b/,
  /\bwindow\b/,
  /\bdocument\b/,
  /\bglobalThis\b/,
  /\bprocess\b/,
  /\beval\b/,
  /\bFunction\b/,
]

export const isFormRuleExpressionSafe = (expression: string): boolean =>
  !BLOCKED_EXPRESSION_PATTERNS.some((re) => re.test(expression))

const cloneRuleData = (
  data: Record<string, unknown>
): Record<string, unknown> => {
  try {
    return structuredClone(data)
  } catch {
    return JSON.parse(JSON.stringify(data)) as Record<string, unknown>
  }
}

export const evaluateFormRuleValue = (
  expression: string,
  data: Record<string, unknown>,
  helpers?: FormRuleExpressionHelpers
): unknown => {
  const trimmed = expression.trim()
  if (!trimmed || !isFormRuleExpressionSafe(trimmed)) return undefined

  try {
    const foldedExpression = foldFormRuleExpression(trimmed, data, helpers)
    return evalExpression(foldedExpression, {
      data: cloneRuleData(data),
    })
  } catch (err) {
    console.error('[FormBehaviorEngine] expression evaluation failed', err)
    return undefined
  }
}

export const evaluateFormRuleExpression = (
  expression: string,
  data: Record<string, unknown>,
  helpers?: FormRuleExpressionHelpers
): boolean | undefined => {
  const result = evaluateFormRuleValue(expression, data, helpers)
  return typeof result === 'boolean' ? result : undefined
}

export const coerceFormRuleIdArray = (value: unknown): number[] | undefined => {
  if (!Array.isArray(value)) return undefined
  return value.map((id) => Number(id)).filter((id) => !Number.isNaN(id))
}

export const coerceFormRuleStringArray = (
  value: unknown
): string[] | undefined => {
  if (!Array.isArray(value)) return undefined
  return value
    .filter((v): v is string => typeof v === 'string')
    .map((v) => v.trim())
    .filter((v) => v.length > 0)
}
